import { Tab } from "@mui/material";
import { useState } from "react";
import { StyledTabBar } from "../../styled/TabBar";

const TabBar = ({ options = [], value, defaultValue, onChange }) => {
  const [internalValue, setInternalValue] = useState(
    defaultValue ?? options[0]?.value ?? null
  );

  if (options.length <= 1) {
    return null;
  }

  const selectedValue = value !== undefined ? value : internalValue;

  const handleChange = (_, newValue) => {
    if (value === undefined) {
      setInternalValue(newValue);
    }
    onChange?.(newValue);
  };

  return (
    <StyledTabBar.Container role="tablist">
      <StyledTabBar.Tabs
        value={selectedValue}
        onChange={handleChange}
        textColor="primary"
        indicatorColor="primary"
      >
        {options.map(({ label, value: optionValue }) => (
          <Tab
            key={optionValue}
            label={label}
            value={optionValue}
            role="tab"
          />
        ))}
      </StyledTabBar.Tabs>
    </StyledTabBar.Container>
  );
};

export default TabBar;
